import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { DATE_TIME_FORMAT } from 'src/app/config/global.config';
import { AppState } from 'src/app/core/app.state';
import { IComparator } from '../../models/comparator.models';
import { GetComparators, SetComparatorLoader } from '../../store/comparator.actions';
import { ComparatorService } from '../../services/comparator.services';
import { ImportComparatorsComponent } from '../import-comparators/import-comparators.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-list-comparators',
  templateUrl: './list-comparators.component.html',
  styleUrls: ['./list-comparators.component.scss']
})
export class ListComparatorsComponent implements OnInit {
  DATE_FORMAT = DATE_TIME_FORMAT;
  comparators$: Observable<IComparator[]> = this.store.select((state) => state.comparators.comparators);
  isAppLoading$ = this.store.select((state) => state.shared.isAppLoading);

  constructor(
    private store: Store<AppState>,
    private router: Router,
    private services: ComparatorService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.store.dispatch(GetComparators());
  }

  importComparators() {
    this.dialog.open(ImportComparatorsComponent, {
      disableClose: true,
      width: '35vw',
      minWidth: '600px'
    })
  }

  details(id: number, validated: boolean) {
    console.log(id, validated);
    
    if(!validated) return
    this.router.navigate(['comparators/', id]);
  }
  
  downloadFile(comparatorFile: IComparator) {
    this.store.dispatch(SetComparatorLoader({ isLoading: true }));
    this.services.getFileComparator(comparatorFile.id).subscribe({
      next: (res: {data: [], object: {file: string}}) => {
        this.store.dispatch(SetComparatorLoader({ isLoading: false }));
        const byteCharacters = atob(res?.object?.file);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = comparatorFile.file_name;
        link.click();
      },
      error: (err) => {
        this.store.dispatch(SetComparatorLoader({ isLoading: false }));
      }
    });
  }

}
